import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { IS_LOCAL_ENV } from "../../App";
import Notification from "../ui-elements/Notification";
import ModalStructure from "../ModalStructure";
import SCDataList from "./modals/SCDataList";
import { FaEye } from "react-icons/fa";

function excelDateToJSDateInLima(excelDate) {
  // Excel cuenta días desde el 1 de enero de 1900
  const excelEpoch = new Date(1900, 0, 1); // 0 = Enero
  // Convertimos el número de días a milisegundos y ajustamos la fecha base
  const utcDate = new Date(
    excelEpoch.getTime() + (excelDate - 2) * 24 * 60 * 60 * 1000
  );

  // Convertimos la fecha UTC a hora local de Lima (UTC-5)
  const limaOffset = -5; // Horario UTC-5
  utcDate.setHours(utcDate.getUTCHours() + limaOffset);

  // Retornamos la fecha ajustada a las 00:00 horas
  utcDate.setHours(0, 0, 0, 0);
  return utcDate;
}

const translatedStatus = {
  Disponible: "available",
  "No disponible": "unavailable",
  Vendido: "sold",
  Otro: "other",
};

const BulkUpload = ({
  subClasses,
  mainImages,
  otherImages,
  handleBulkCreate,
  bulkLoadToParent,
  handleClose,
}) => {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [products, setProducts] = useState([]);
  const [errors, setErrors] = useState([]);

  const [subClassesList, setSubClassesList] = useState([]);
  const [mainImagesList, setMainImagesList] = useState([]);
  const [otherImagesList, setOtherImagesList] = useState([]);

  useEffect(() => {
    // Filter out any undefined or null values
    const validSubClasses = subClasses
      .map((doc) => doc.id)
      .filter((id) => id != null);

    const validMainImages = mainImages
      .filter((doc) => doc.isMainImage)
      .map((doc) => doc.id)
      .filter((id) => id != null);

    const validOtherImages = otherImages
      .filter((doc) => !doc.isMainImage)
      .map((doc) => doc.id)
      .filter((id) => id != null);

    setSubClassesList(validSubClasses);
    setMainImagesList(validMainImages);
    setOtherImagesList(validOtherImages);

    // Set loading to false once lists are initialized
    setLoading(false);
  }, [subClasses, mainImages, otherImages]);

  const [showSubClassModal, setShowSubClassModal] = useState(false);
  const [subClassInfo, setSubClassInfo] = useState(null);

  const validateRow = (row) => {
    if (loading || !subClassesList.length) {
      console.warn("Lists not fully initialized yet");
      return ["Los datos de validación aún no están listos"];
    }

    IS_LOCAL_ENV && console.log("SUBCLASES: ", subClassesList);
    IS_LOCAL_ENV && console.log("row: ", row);

    try {
      const errorList = [];

      // Validar código de producto único
      if (!row["Codigo"])
        errorList.push("El código del producto es obligatorio.");
      if (products.some((p) => p.code === row["Codigo"])) {
        errorList.push(`El código ${row["Codigo"]} ya existe en el archivo.`);
      }

      //Validar nombre
      if (!row["Nombre"])
        errorList.push("El nombre del producto es obligatorio.");
      if (row?.["Nombre"].trim() === "")
        errorList.push("El nombre del producto no puede estar vacío.");

      // Validar subclase
      // if (!classesList.includes(row["Id Clase"]))
      //   errorList.push(`La clase ${row["Id Clase"]} no es válida.`);
      if (!subClassesList.includes(row["Id Subclase"].trim()))
        errorList.push(`La subclase ${row["Id Subclase"]} no es válida.`);

      // Validar ID de imágenes
      if (!row["ID Imagen Principal"])
        errorList.push("Falta el ID de imagen principal.");
      if (!mainImagesList.includes(row["ID Imagen Principal"].trim()))
        errorList.push(
          `La imagen principal ${row["ID Imagen Principal"]} no es válida.`
        );

      // if (!row["ID Imágenes Secundarias"])
      //   errorList.push("Falta el ID de imágenes secundarias.");
      if (row["ID Imágenes Secundarias"] != undefined) {
        const secondaryImages = row["ID Imágenes Secundarias"]
          ?.split(",")
          ?.map((s) => s.trim());
        const invalidImages = secondaryImages.filter(
          (img) => !otherImagesList.includes(img)
        );
        if (invalidImages.length > 0)
          errorList.push(
            `Las imágenes secundarias ${invalidImages.join(
              ", "
            )} no son válidas.`
          );
      }

      // Validar estado
      const validStatuses = ["available", "unavailable", "sold", "other"];
      if (!validStatuses.includes(translatedStatus[row["Estado"]]))
        errorList.push(`El estado ${row["Estado"]} no es válido.`);

      // Validar fecha
      if (isNaN(new Date(row["Fecha de ingreso"]).getTime()))
        errorList.push("Fecha de ingreso no válida.");

      // Validar precios
      if (isNaN(Number(row["Precio de compra"])))
        errorList.push("El precio de compra debe ser un número.");
      if (isNaN(Number(row["Precio de venta"])))
        errorList.push("El precio de venta debe ser un número.");

      // Validar proveedor
      if (typeof row["Proveedor"] !== "string")
        errorList.push("El nombre del proveedor debe ser un texto.");
      if (!row["RUC"])
        errorList.push("El RUC del proveedor no puede estar vacío.");
      // if (isNaN(Number(row["RUC"])))
      //   errorList.push("El RUC del proveedor debe ser un número.");

      // Validar especificaciones principales test
      // if (!row["Specs Principales"])
      //   errorList.push("Faltan las especificaciones principales.");

      return errorList;
    } catch (err) {
      Notification({
        title: "Error",
        text: "Algo salió mal al cargar el archivo...",
        type: "Error",
      });
      IS_LOCAL_ENV && console.error(err);
      window.location.reload();
    }
  };

  const handleFileUpload = (event) => {
    try {
      const file = event.target.files[0];

      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Asumimos que el archivo tiene un solo sheet
        const sheetName = workbook.SheetNames[0];
        const sheetData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);

        const validatedProducts = [];
        const validationErrors = [];

        sheetData.forEach((row, index) => {
          console.log("row: ", row);
          const errors = validateRow(row);
          if (errors.length > 0) {
            validationErrors.push({ row: index + 2, errors });
          } else {
            let fms = [];
            let fmsc = []; //array de codigos. todos en uno
            console.log("row: ", row);
            row?.["Specs principales (Códigos)"]?.split("\n")?.map((spc, i) => {
              let codes = spc.split(",");
              codes.map((code, i) => {
                fmsc = [...fmsc, code.trim()];
              });
            });

            let count = -1;
            row?.["Specs Principales"]?.split("\n")?.map((spec, i) => {
              let [name, options] = spec.split(":");
              fms = [
                ...fms,
                {
                  name: name.trim(),
                  values: options.split(",").map((opt, idx) => {
                    count++;
                    return {
                      value: opt.trim().toString(),
                      code: fmsc[count].trim().toString(),
                    };
                  }),
                },
              ];
            });

            validatedProducts.push({
              name: row["Nombre"],
              code: row["Codigo"],
              subClass: row["Id Subclase"],
              //class: row["Id Clase"],
              mainImage: row["ID Imagen Principal"],
              images:
                row?.["ID Imágenes Secundarias"]
                  ?.split(",")
                  ?.map((i) => i.trim()) || null,
              entryDate: excelDateToJSDateInLima(row["Fecha de ingreso"]),
              providerName: row["Proveedor"],
              providerRuc: row["RUC"].toString(),
              mainSpecs: fms ? fms : null,
              otherSpecs:
                row?.["Specs secundarias"]?.split("\n")?.map((spec, index) => {
                  return {
                    name: spec.split(":")[0].trim(),
                    value: spec.split(":")[1].trim(),
                  };
                }) || null,
              purchasePrice: parseFloat(row["Precio de compra"]).toFixed(2),
              salePrice: parseFloat(row["Precio de venta"]).toFixed(2),
              inOffer: row["Oferta"] === "sí",
              offerDiscount: row["Descuento"]
                ? parseInt(row["Descuento"], 10)
                : 0,
              offerEndDate:
                excelDateToJSDateInLima(row["Fecha fin oferta"]) || null,
              postSaleWait: row["Tiempo de espera post venta"]
                ? parseInt(row["Tiempo de espera post venta"], 10)
                : 2,
            });
          }
        });

        setProducts(validatedProducts);
        setErrors(validationErrors);
      };

      reader.readAsArrayBuffer(file);
    } catch (err) {
      Notification({
        title: "Error",
        text: "Algo salió mal al cargar el archivo...",
        type: "Error",
      });
      IS_LOCAL_ENV && console.error(err);

      return;
    }
  };

  const handleSubmit = async () => {
    try {
      setUploading(true);
      IS_LOCAL_ENV && console.log("products a subir: ", products);
      const { createdProducts, message } = await handleBulkCreate(products); //es un custom hook
      IS_LOCAL_ENV && console.log("docs creados: ", createdProducts);
      bulkLoadToParent(createdProducts);
      setUploading(false);
      Notification({
        title: "Operación completada",
        text: message,
        type: "Success",
      });
      handleClose();
    } catch (error) {
      setUploading(false);
      Notification({
        title: "Operación inválida",
        text: "Hubo un error al cargar los productos.",
        type: "Error",
      });
      IS_LOCAL_ENV && console.log("error: ", error);
    }
  };

  return (
    <div className="flex flex-col w-full items-center justify-center font-poppins gap-4">
      <div className="flex flex-wrap w-full items-center justify-center font-poppins gap-2">
        {subClasses.map((subClass, i) => {
          return (
            <button
              key={i}
              className="flex flex-row items-center bg-white border-[1px] border-accent-green hover:bg-light-green gap-2  text-dark-green rounded-full py-2 px-4 text-base font-poppins"
              onClick={() => setSubClassInfo(subClass)}
            >
              {subClass.name}
              <FaEye />
            </button>
          );
        })}
      </div>

      {/**modal info subcklase */}
      {subClassInfo && (
        <ModalStructure
          handleCloseModal={() => setSubClassInfo(null)}
          customMaxW={"max-w-[500px]"}
        >
          <SCDataList
            subClassInfo={subClassInfo}
            mainImages={mainImages.filter(
              (img) => img.subClass.id == subClassInfo.id
            )}
            otherImages={otherImages.filter(
              (img) => img.subClass.id == subClassInfo.id
            )}
          />
        </ModalStructure>
      )}

      <span className="text-base ">Cargar excel de productos</span>
      <input
        type="file"
        accept=".xlsx, .xls"
        onChange={handleFileUpload}
        className="border-[1px] rounded-full "
      />
      <button
        onClick={handleSubmit}
        disabled={products.length === 0 || uploading}
        className={`${
          products.length === 0 || uploading
            ? "bg-light-gray cursor-not-allowed"
            : "bg-accent-green hover:bg-dark-green"
        } text-white rounded-full px-4 py-2 font-bold font-poppins text-nowrap transition-all duration-100 w-fit`}
      >
        Subir
      </button>

      {errors.length > 0 && (
        <div>
          <h3>Errores de Validación:</h3>
          <ul>
            {errors.map((error, index) => (
              <li key={index}>
                Fila {error.row}: {error.errors.join(", ")}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default BulkUpload;
